import { createFileRoute } from '@tanstack/react-router'
import type { BrokenConnectionHealth } from '@/modules/shared/connection-access'
import type { OAuthPlatform } from '@/data/adapters/api/oauth.api'

export interface ConnectionRecoverySearch {
  feature?: string
  platform: OAuthPlatform
  reason: BrokenConnectionHealth
  next?: string
  status?: string
  service?: string
  store_id?: string
  error?: string
}

const platforms = new Set<OAuthPlatform>(['tiktok_shop', 'tiktok_business'])
const reasons = new Set<BrokenConnectionHealth>(['missing', 'setup-required', 'invalid'])

export const Route = createFileRoute('/$orgSlug/$clientSlug/connection')({
  validateSearch: (raw: Record<string, unknown>): ConnectionRecoverySearch => ({
    feature: typeof raw.feature === 'string' ? raw.feature : undefined,
    platform: platforms.has(raw.platform as OAuthPlatform)
      ? (raw.platform as OAuthPlatform)
      : 'tiktok_shop',
    reason: reasons.has(raw.reason as BrokenConnectionHealth)
      ? (raw.reason as BrokenConnectionHealth)
      : 'missing',
    next: typeof raw.next === 'string' ? raw.next : undefined,
    status: typeof raw.status === 'string' ? raw.status : undefined,
    service: typeof raw.service === 'string' ? raw.service : undefined,
    store_id: typeof raw.store_id === 'string' ? raw.store_id : undefined,
    error: typeof raw.error === 'string' ? raw.error : undefined,
  }),
})
